import { ExperimentKey } from 'services/statsig/types';
import { useStatsig } from 'shared/hooks/statsig/useStatsig';

export const useDirectDepositLoadingComponent = () => {
  const { experimentSegmentActive } = useStatsig();

  const skipIntroScreen = experimentSegmentActive(
    ExperimentKey.DD_INSTANT_SWITCH_INTRO_SCREEN,
    'Test',
  );

  return {
    skipIntroScreen,
  };
};

export default useDirectDepositLoadingComponent;
